import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import { useIsMobile } from "@/hooks/useResponsive";

const ROW_COUNT = 8;
const COL_COUNT = 5;
const CARD_COUNT = 5;

export const OpportunitiesSkeleton = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {Array.from({ length: CARD_COUNT }).map((_, i) => (
          <Box key={i} sx={{ p: 1.5, border: "1px solid var(--divider-main)", borderRadius: "var(--border-radius-main)" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
              <Skeleton variant="text" width="45%" height={22} />
              <Skeleton variant="text" width={90} height={18} />
            </Box>
            <Skeleton variant="text" width="70%" height={16} />
            <Skeleton variant="text" width="55%" height={16} />
            <Skeleton variant="text" width="60%" height={16} />
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Box>
      <table aria-label="Loading opportunities">
        <tbody>
          {Array.from({ length: ROW_COUNT }).map((_, ri) => (
            <tr key={ri}>
              {Array.from({ length: COL_COUNT }).map((_, ci) => (
                <td key={ci} style={{ padding: "8px 12px" }}>
                  <Skeleton variant="text" width="80%" height={24} />
                </td>
              ))}
              <td style={{ padding: "8px 12px" }}>
                <Skeleton variant="circular" width={28} height={28} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  );
};
